module.exports = __webpack_public_path__ + "img/logo.9023fde6.png";